import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentPick() {
  return (
    <FulfillmentQueue title="Pick" statusFilter="picking" emptyMessage="No orders in picking" />
  );
}
